module.exports = __webpack_public_path__ + "static/media/logo.e7a09119.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/logo.svg
// module id = 346
// module chunks = 0